import React from 'react';
import { CashierWorkplace } from '../../components/CashierWorkplace';
import { useData } from '../../contexts/DataContext';
import { useTheme } from '../../contexts/ThemeContext';

export const CashierWorkplacePage: React.FC = () => {
  const { theme } = useTheme();
  const { products } = useData();

  return <CashierWorkplace theme={theme} products={products.items} />;
};
